module.exports = __webpack_public_path__ + "FondoTituloVentajas.0ddbf0500d367a9b60d8.png";


//////////////////
// WEBPACK FOOTER
// /mnt/c/Dev/CoolDevs/modos/app/src/assets/FondoTituloVentajas.png
// module id = ../../../../../src/assets/FondoTituloVentajas.png
// module chunks = styles